import I18n from 'I18n';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { Link } from 'foundations-components/transitional/components/Link';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import _get from 'hs-lodash/get';
import _some from 'hs-lodash/some';
import { useContext, useEffect, useState } from 'react';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { EMPTY_PROPERTY_STATE_TEXT } from '../../../constants/emptyState';
import { PROPERTIES_VIEWS, PROPERTY_NAME_TO_REFERENCE_TYPE } from '../../../constants/properties';
import { PropertiesContext } from '../../../contexts/properties/context';
import { Label, PropertyValue } from './FormattedCardProperty.style';
import { DuplicateIcon } from 'foundations-assets/icons/components/DuplicateIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function FormattedCardProperty({
  propertyKey,
  value,
  propertyDetails,
  view = PROPERTIES_VIEWS.ASSOCIATION_CARD,
  entityType,
  appName
}) {
  const {
    externalOptions,
    mentionOwners,
    searchProperties
  } = useContext(PropertiesContext);
  const type = _get(propertyDetails, 'type');
  const [valueLabel, setValueLabel] = useState('');
  let formattedValue;

  // match logic
  // property value with external options to show nice label
  useEffect(() => {
    if (type === 'enumeration') {
      const currentProperty = searchProperties[entityType].find(property => property.name === propertyKey);
      if (currentProperty && currentProperty.externalOptions) {
        const hardcodedRefType = _get(PROPERTY_NAME_TO_REFERENCE_TYPE[entityType], propertyKey, '');
        const objectRefType = currentProperty.referenceType || currentProperty.referencedObjectType || hardcodedRefType || '';
        const options = externalOptions[entityType][objectRefType];
        if (options && options.results) {
          const currentOption = options.results.find(el => el.id === value);
          if (currentOption) {
            setValueLabel(currentOption.label);
          }
        }
      }
    }
  }, [entityType, searchProperties, propertyDetails, propertyKey, externalOptions, value, type]);
  switch (type) {
    case 'html':
      formattedValue = value && /*#__PURE__*/_jsx(SanitizedText, {
        body: value
      });
      break;
    case 'string':
      if (_some(['email', 'domain'], key => propertyKey.includes(key)) && view === PROPERTIES_VIEWS.ASSOCIATION_CARD) {
        const hrefLink = propertyKey.includes('email') ? `mailto:${value}` : `https://${value}`;
        formattedValue = /*#__PURE__*/_jsxs(TFlex, {
          align: "baseline",
          justify: "start",
          children: [/*#__PURE__*/_jsx(Link, {
            "data-test-id": `${appName}-crm-object-property-link`,
            external: true,
            href: hrefLink,
            truncate: true,
            children: value
          }), /*#__PURE__*/_jsx(CopyButton, {
            responsive: false,
            tooltipPlacement: "bottom",
            use: "transparent",
            value: value,
            children: /*#__PURE__*/_jsx(DuplicateIcon, {})
          })]
        });
        return formattedValue;
      } else {
        formattedValue = value;
      }
      break;
    case 'enumeration':
      {
        const property = searchProperties[entityType].find(item => item.name === propertyKey);
        if (property && property.referencedObjectType === 'OWNER') {
          const owner = mentionOwners.find(item => item.value === Number(value));
          formattedValue = _get(owner, 'text', '') || value;
          break;
        }
        const option = _get(property, 'options', []).find(item => item.value === value);
        formattedValue = _get(option, 'label', '') || value;
        break;
      }
    case 'datetime':
    case 'date':
      {
        if (value && value !== '--') {
          const date = I18n.moment(value);
          formattedValue = value && date.isValid() && /*#__PURE__*/_jsx(FormattedDateTime, {
            value: I18n.moment(value),
            format: "L LT z",
            type: "userTz"
          });
        }
        break;
      }
    default:
      formattedValue = value;
      break;
  }
  if (!propertyDetails) return null;
  if (view === PROPERTIES_VIEWS.PREVIEW_MODAL) {
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(Label, {
        children: _get(propertyDetails, 'label', propertyKey)
      }), /*#__PURE__*/_jsx(PropertyValue, {
        "data-test-id": `${appName}-crm-object-property-value`,
        children: valueLabel || formattedValue || EMPTY_PROPERTY_STATE_TEXT
      })]
    }, propertyKey);
  }
  return /*#__PURE__*/_jsxs("span", {
    "data-test-id": `${appName}-crm-object-property-label`,
    children: [_get(propertyDetails, 'label', propertyKey), ":\xA0", valueLabel || formattedValue || EMPTY_PROPERTY_STATE_TEXT]
  });
}
export default FormattedCardProperty;